// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"2c542001a400dea6f0a1","610":"28bdf02a38457b27e959","678":"a7f3c3541a7d7d8a6685","711":"99d27a091e489a28ba73","883":"0a2328fdf97ed62a7fa5","932":"28550f3b020eda131110"}[chunkId] + ".js";
};